const BADGE = {
  read:   { label: "Read",   short: "R", bg: "#dbeafe", fg: "#1d4ed8", dot: "#3b82f6" },
  write:  { label: "Write",  short: "W", bg: "#d1fae5", fg: "#065f46", dot: "#10b981" },
  notify: { label: "Notify", short: "N", bg: "#fef3c7", fg: "#92400e", dot: "#f59e0b" },
};
 

const PropertyBadge = ({ type, expanded }) => {
  const b = BADGE[type];
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      fontSize: expanded ? 11 : 9,
      fontWeight: 700,
      padding: expanded ? "3px 8px" : "2px 6px",
      borderRadius: 20,
      background: b.bg,
      color: b.fg,
      transition: "all 0.2s",
      letterSpacing: 0.2,
    }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: b.dot, flexShrink: 0 }} />
      {expanded ? b.label : b.short}
    </span>
  );
};

export default PropertyBadge;